<script setup lang="ts">
import BackstageVideo from '@/components/common/BackstageVideo.vue';
import BackstageImage from './BackstageImage.vue';

export interface Props {
  description: string;
  browserNotSupportedVideoText: string;
  playVideoAriaLabel: string;
  title?: string;
  titleUrl?: string;
  imageUrl?: string;
  video?: {
    url: string;
    thumbnail: string;
  };
}

defineProps<Props>();
</script>

<template>
  <div class="tutorial-guidance-step-content">
    <header v-if="title" id="driver-popover-title">
      <a v-if="titleUrl" class="driver-popover-title link" :href="titleUrl" target="_blank" rel="noopener noreferrer">
        {{ title }}
      </a>
      <p v-else class="driver-popover-title">{{ title }}</p>
    </header>
    <BackstageImage class="driver-popover-image" v-if="imageUrl" :src="imageUrl" :alt="description" />
    <BackstageVideo
      v-if="video"
      :src="video.url"
      :poster="video.thumbnail"
      :fallback-text="browserNotSupportedVideoText"
      :play-aria-label="playVideoAriaLabel"
      class="driver-popover-video-container" />
    <p class="driver-popover-description">{{ description }}</p>
  </div>
</template>

<style lang="scss" scoped>
.tutorial-guidance-step-content {
  header {
    text-align: left;
    margin-bottom: 16px;
  }

  .driver-popover-image {
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 6px;
    object-fit: contain;
  }

  .driver-popover-title {
    font-size: 26px !important;
    display: inline-block;

    &.link {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .driver-popover-description {
    text-align: left;
    font-size: 20px !important;
    font-weight: 400;
  }
}
</style>
